import type { CheckDefinition, Issue } from '@/features/inconsistencies/inconsistencies'

function escape(value: string): string {
  return /[",\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value
}

/** One check's rows as CSV (same conventions as the catalog export: comma, CRLF). */
export function formatIssuesCsv(check: CheckDefinition, issues: Issue[]): string {
  const header = [
    check.headers.subject,
    'Код / ключ',
    check.headers.where,
    check.headers.detail,
    'Вид проблемы',
    'Проблема',
    'Ссылка',
  ]
  const origin = typeof window === 'undefined' ? '' : window.location.origin
  const lines = [header.map(escape).join(',')]
  for (const issue of issues) {
    lines.push(
      [
        issue.subject,
        issue.subjectNote,
        issue.where,
        issue.detail,
        issue.kind,
        issue.problem,
        issue.link ? `${origin}${issue.link}` : '',
      ]
        .map(escape)
        .join(','),
    )
  }
  return `${lines.join('\r\n')}\r\n`
}

/** Downloads the CSV; a BOM so Excel opens Cyrillic text correctly. */
export function downloadIssuesCsv(check: CheckDefinition, issues: Issue[]): void {
  const blob = new Blob([`\uFEFF${formatIssuesCsv(check, issues)}`], {
    type: 'text/csv;charset=utf-8',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `estimatepro-${check.id}-${new Date().toISOString().slice(0, 10)}.csv`
  link.click()
  URL.revokeObjectURL(url)
}
